import React, { lazy, Suspense } from 'react';

const Landing = lazy(() => import('./Landing'));
const NewTeam = lazy(() => import('./NewTeam'));
const ActivateTeam = lazy(() => import('./ActivateTeam'));
const JoinTeam = lazy(() => import('./JoinTeam'));
const FacultyMentors = lazy(() => import('./FacultyMentors'));

const routes = [
  {
    path: '/',
    exact: true,
    name: 'Intro',
    includeInNav: false,
    main: () => <Landing />,
  },
  // {
  //   path: '/new-team',
  //   exact: true,
  //   name: 'Create a Team',
  //   includeInNav: true,
  //   main: () => <NewTeam />,
  // },
  {
    path: '/validate-team/:id',
    exact: true,
    name: 'Activate Team',
    includeInNav: false,
    main: () => <ActivateTeam />,
  },
  // {
  //   path: '/join-team',
  //   exact: true,
  //   name: 'Join a Team',
  //   includeInNav: true,
  //   main: () => <JoinTeam />,
  // },
  {
    path: '/faculty-mentor',
    exact: true,
    name: 'Faculty Registration',
    includeInNav: true,
    main: () => <FacultyMentors />,
  },
];

export default routes;
